<div
	class="summary-card focus-link"
	(click)="stepClick(step)"
	[ngClass]="{
		'hover-pointer': cssHover,
		'is-gray': cssGrayOut,
		faded: cssFaded
	}"
	[tabindex]="0"
	(keydown.enter)="stepClick(step)">
	<div class="summary-card__title">
		<a href="javascript:">{{ titleKey | translate }}</a>
	</div>
	<div class="summary-card__content-container">
		<div class="summary-card__content text-center">
			<!-- inserted by parent -->
			<ng-content select="[iconContainer]"></ng-content>
			<!-- inserted by parent -->
			<ng-content select="[detailsContainer]"></ng-content>
		</div>
	</div>
	<!-- inserted by parent -->
	<div class="summary-card__additional-content">
		<ng-content select="[additionalContainer]"></ng-content>
	</div>
</div>
